export const MISSING_USER_PERMISSIONS = 'MISSING_USER_PERMISSIONS';
export const MISSING_HUB_SCOPES = 'MISSING_HUB_SCOPES';
export const ALREADY_INSTALLED = 'ALREADY_INSTALLED';
export const INCOMPATIBLE_INSTALLS = 'INCOMPATIBLE_INSTALLS';